export default __webpack_public_path__ + "locales/tr/PeopleTranslations.json?hash=3452d08ad7f9f1243643e8016d5d768f";